export const CONDITION_STATUS = ["neuwertig", "gut erhalten", "deutliche Nutzungsspuren", "beschädigt oder abgerockt"];

export const TIME_OF_YEAR = ["Frühjahr", "Sommer", "Herbst ", "Winter"];

export const getTimeFactor = (
  brand: { brand: string; category: number; index: number },
  time: number,
  price: number
): number => {
  if (brand.brand?.toLocaleLowerCase() === "andere") {
    return (75 / 100) * time ** -0.52;
  } else if (brand.category === 2) {
    return (86 / 100) * time ** -0.46;
  } else {
    return (96 / 100) * time ** -0.4;
  }
};

export const getConditionFactor = (condition: string): number => {
  if (condition === "neuwertig") return 0.95;
  if (condition === "gut erhalten") return 0.85;
  if (condition === "deutliche Nutzungsspuren") return 0.7;
  if (condition === "beschädigt oder abgerockt") return 0.4;
  return 0.4;
};

export const getLegendFactor = (isNew: string): number => (isNew === "ja" ? 1.5 : 1);

export const getSeasonFactor = (season: string): number => {
  if (season === "Frühjahr") return 1.05;
  if (season === "Sommer") return 1;
  if (season === "Herbst") return 0.9;
  if (season === "Winter") return 0.8;
  return 0.8;
};

export const getBikeValue = (
  purchasePrice: number,
  timeFactor: number,
  conditionFactor: number,
  legendFactor: number,
  seasonFactor: number
): number => purchasePrice * timeFactor * conditionFactor * legendFactor * seasonFactor;
